var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'modal-background', _vm.visibilityClass, _vm.colorClass ],attrs:{"id":"giz-modal-background"},on:{"click":function($event){return _vm.modalCloseAll()}}})}
var staticRenderFns = []

export { render, staticRenderFns }